import { IInitialisable } from "../../interfaces/IInitialisable";
import { querySelectorOrThrow } from "../../utils/dom/querySelectorOrThrow";
import { toggleClass } from "../../utils/dom/toggleClass";
import { Basket } from "../global-header/Basket";

export class Modal implements IInitialisable {
	protected documentHelper = document;
	private querySelectorOrThrow = querySelectorOrThrow;
	private templateWrapper: HTMLElement;
	private scrollPosition: number;
	private toggleClassHelper = toggleClass;
	private basketQuantity: number[] = [];

	constructor() {
		this.handleModalClose = this.handleModalClose.bind(this);
		this.handleModalOpen = this.handleModalOpen.bind(this);
		this.handleAnimationEnd = this.handleAnimationEnd.bind(this);
	}

	// tested
	public Init() {
		const components = document.querySelectorAll<HTMLElement>('[data-cmpt="add-to-basket-modal"].cmpt');
		if (components.length > 0) {
			this.setupComponent();
		}
	}

	// tested
	private setupComponent() {
		this.templateWrapper = this.querySelectorOrThrow<HTMLInputElement>(this.documentHelper, '.add-to-basket-modal__content');

		this.addEventListenerToTemplateElements('.js_modal_open_trigger', 'click', this.handleModalOpen);
		this.addEventListenerToTemplateElements('.js_modal_close_trigger', 'click', this.handleModalClose);
	}

	// tested
	private addEventListenerToTemplateElements<T extends Element>(elementSelector: string, eventName: string, callback: (evt: Event) => void) {
		const els = this.documentHelper.querySelectorAll<T>(elementSelector);
		els.forEach(x => {
			x.addEventListener(eventName, (evt) => callback(evt));
		});
		return Array.from(els);
	}

	// tested
	private handleModalOpen(e: Event) {
		e.preventDefault();
		this.toggleClassHelper(this.templateWrapper, 'modal-triggered');
		this.handleUspBannerState();
		this.handleScrollEnable();
		this.handleProductQuantity() ;
	}

	// tested
	private handleModalClose(e: Event) {
		e.preventDefault();
		this.templateWrapper.setAttribute('modal-closing', '');
		this.templateWrapper.addEventListener('animationend', this.handleAnimationEnd);
		this.handleUspBannerState();
		this.handleScrollDisable();
		new Basket().Init();
	}

	// tested
	private handleUspBannerState() {
		const uspBanner = this.documentHelper.querySelector(".usp__animation-toggle.js_cmpt") as HTMLElement;
		if (uspBanner) {
			this.toggleClassHelper(uspBanner, 'paused');
		}
	}

	// tested
	private handleScrollEnable() {
		this.scrollPosition = this.documentHelper.documentElement.scrollTop;
		this.documentHelper.documentElement.style.top = `-${this.scrollPosition}px`;
		this.documentHelper.documentElement.classList.add('no-scroll');
	}

	// tested
	private handleScrollDisable() {
		const templateWrapper = this.documentHelper.documentElement;
		templateWrapper.classList.remove('no-scroll');
		templateWrapper.style.scrollBehavior = "auto";
		templateWrapper.scrollTop = this.scrollPosition;
		templateWrapper.style.removeProperty('top');
		templateWrapper.style.removeProperty('scroll-behavior');
	}

	// tested
	private handleAnimationEnd() {
		this.templateWrapper.removeAttribute('modal-closing');
		this.toggleClassHelper(this.templateWrapper, 'modal-triggered');
		this.templateWrapper.removeEventListener('animationend', this.handleAnimationEnd);
	}

	// tested
	private handleProductQuantity() {
		const addToBasketForm = this.documentHelper.querySelector('#js__addToBasket__form') as HTMLFormElement;
		if (addToBasketForm) {
			const quantityInput = <HTMLInputElement>addToBasketForm.elements['Quantity'];
			const productQuantity = quantityInput.value.trim();
			this.basketQuantity = [...this.basketQuantity, +productQuantity];
			this.renderProductQuantityOnModal(+productQuantity);
		}
	}

	// tested
	private renderProductQuantityOnModal(qty: number) {
		const templateWrapper = this.querySelectorOrThrow<HTMLElement>(this.documentHelper, '.add-to-basket-modal__content__body__quantity__amt');
		return (templateWrapper.innerHTML = qty.toString());
	}
}
